import { useDispatch, useSelector } from 'react-redux';

import EditItem from '../../../../shared/components/IconButtons/EditItem';
import { handleAssociadoChange } from '../../../../../store/reducers/associadoSlice';
import CampoInputTexto from '../../../../shared/components/CampoInputComButton/CampoInputTexto/CampoInputTexto';

const CampoInputNumeroFuncionarios = ({ onClick, editButton, disabled }) => {

    const dispatch = useDispatch()
    const { employees_number } = useSelector(state => state.associadoState)
    
    const handleChange = (name, value) => {
        dispatch(handleAssociadoChange({[name]: value}))
    }
    const handleClick = (e) => {
        e.preventDefault()
        onClick("employees_number")
    }

    return (
        <CampoInputTexto
            id="inputNumeroFuncionarios"
            titulo="Número funcionários*"
            onChange={handleChange}
            name="employees_number"
            value={employees_number}
            label={"obrigatório"}
            required={true}
            disabled={disabled}
        >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputTexto>
    )
}

export default CampoInputNumeroFuncionarios
